import { createFileRoute, Link } from "@tanstack/react-router";
import { isNative } from "@/lib/nativeAuth";
import { useSeo } from "@/lib/seo";
import { PrivacyContent } from "@/components/legal/PrivacyContent";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  useSeo({
    title: "Privacy Policy | GreenTrack",
    description: "How GreenTrack collects, stores, and protects your trip, green card, and family data. We never sell or share your personal data.",
    path: "/privacy",
  });

  return (
    <div className="min-h-screen bg-paper text-ink">
      <div className="mx-auto max-w-3xl px-6 py-16 sm:px-10 sm:py-24">
        <Link
          to={isNative() ? "/app" : "/"}
          className="text-[10px] font-bold uppercase tracking-widest text-ink-muted hover:text-ink-deep"
        >
          ← Back to GreenTrack
        </Link>

        <div className="mt-8">
          <PrivacyContent />
        </div>
      </div>
    </div>
  );
}
